module.exports = __webpack_public_path__ + "img/Vietnam.7936b301.svg";